// SafeAreaGamePlay.js
var SafeAreaGamePlay = pc.createScript('safeAreaGamePlay');

SafeAreaGamePlay.attributes.add('debugSafeAreaTop', {type: 'number'});
SafeAreaGamePlay.attributes.add('debugSafeAreaBottom', {type: 'number'});
SafeAreaGamePlay.attributes.add("topWall", {type:"entity"});
SafeAreaGamePlay.attributes.add("bottomWall", {type:"entity"});
SafeAreaGamePlay.attributes.add("homeWall", {type:"entity"});
SafeAreaGamePlay.attributes.add("matchInfoWall", {type:"entity"});
SafeAreaGamePlay.attributes.add("eventsWall", {type:"entity"});
SafeAreaGamePlay.attributes.add("bottomRightWall", {type:"entity"});
SafeAreaGamePlay.attributes.add("bottomLeftWall", {type:"entity"});
SafeAreaGamePlay.attributes.add("coverLeftWall", {type:"entity"});
SafeAreaGamePlay.attributes.add("coverRightWall", {type:"entity"});
SafeAreaGamePlay.attributes.add("shakeButtonWall", {type:"entity"});
SafeAreaGamePlay.attributes.add("jokerButtonWall", {type:"entity"});
SafeAreaGamePlay.attributes.add("shakeButton", {type:"entity"});
SafeAreaGamePlay.attributes.add("jokerButton", {type:"entity"});

SafeAreaGamePlay.prototype.initialize = function () {
    
    SafeAreaGamePlay.instance = this;

    this._initialHeight = this.entity.element.height;

    if (PlayerManager.instance.levelData.levelName != "Donut Shop") {
        this.shakeButton.enabled = true;
    }
    if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
        this.jokerButton.enabled = true;
    }
    this.safeAreaUpdate();
};

SafeAreaGamePlay.prototype.updateEventWall = function () {
    var marginNewEventWallZ = 4.522 * this.topPercentage * 0.05;
    let newEventWallZ = -4.522 + marginNewEventWallZ;
    this.eventsWall.rigidbody.teleport(new pc.Vec3(-1.682, 0, newEventWallZ));
};

SafeAreaGamePlay.prototype.safeAreaUpdate = function() {

    var topPixels = this.debugSafeAreaTop;
    var bottomPixels = this.debugSafeAreaBottom;
     
    var screenResHeight = window.innerHeight * window.devicePixelRatio;
    
    this.topPercentage = topPixels / screenResHeight;
    var bottomPercentage = bottomPixels / screenResHeight;
    
    var marginTop = this._initialHeight * this.topPercentage;
    var marginBottom = this._initialHeight * bottomPercentage;
    
    var margin = this.entity.element.margin;
    margin.y = marginBottom;
    margin.w = marginTop;
    this.entity.element.margin = margin;

   this.topPercentage = 0.04932182490752158;

    var marginTopZ = 5.407 * this.topPercentage * 2.2;
    let newTopZ = -5.407 + marginTopZ;
    this.topWall.rigidbody.teleport(new pc.Vec3(-1.682, 0, newTopZ));


    var marginNewHomeZ = 4.325 * this.topPercentage;
    let newHomeZ = -4.325 + marginNewHomeZ;
    this.homeWall.rigidbody.teleport(new pc.Vec3(-2.913,0,newHomeZ));

    var marginNewMatchInfoZ = 4.77 * this.topPercentage;
    let newMatchInfoZ = -4.77 + marginNewMatchInfoZ;
    this.matchInfoWall.rigidbody.teleport(new pc.Vec3(0.066,0,newMatchInfoZ));

    if (bottomPercentage != 0) {

        var differenceBottomRightZ = 5.387 * bottomPercentage;
        let marginBottomRightZ = 5.387 - differenceBottomRightZ;
        this.bottomRightWall.rigidbody.teleport(new pc.Vec3(2.343, 1.985, marginBottomRightZ));

        var differenceBottomLeftZ = 5.407 * bottomPercentage;
        let marginBottomLeftZ = 5.407 - differenceBottomLeftZ;
        this.bottomLeftWall.rigidbody.teleport(new pc.Vec3(-2.355, 1.985, marginBottomLeftZ));

        this.shakeButton.setLocalPosition(new pc.Vec3(this.shakeButton.getLocalPosition().x,this.shakeButton.getLocalPosition().y-bottomPixels, this.shakeButton.getLocalPosition().z));
        this.jokerButton.setLocalPosition(new pc.Vec3(this.jokerButton.getLocalPosition().x,this.jokerButton.getLocalPosition().y-bottomPixels, this.jokerButton.getLocalPosition().z));
    }
    else {
        //console.log("Bottom Percentage Sıfır");
    }


};

